import { ErrorHandler, Injectable, isDevMode } from '@angular/core';
import { LoggerService } from './logger.service';

@Injectable({
  providedIn: 'root',
})
export class SiErrorHandler implements ErrorHandler {
  constructor(private logger: LoggerService) {
  }

  public handleError(error: any): void {
    if (isDevMode()) {
      console.log(error);
    }

    this.logger.error(error);
  }
}
